(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-slider"] && !Shopify.designMode) return;
  try {
    
  const initBrandSliders = () => {
    document.querySelectorAll('[data-brand-slider]').forEach((root) => {
      if (root.dataset.brandSliderReady === 'true') return;

      const track = root.querySelector('[data-brand-slider-track]');
      if (!track) return;

      root.dataset.brandSliderReady = 'true';

      const enabled = root.dataset.autoplay === 'true';
      const speed = Number(root.dataset.autoplaySpeed || 3000);
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!enabled || prefersReducedMotion || speed < 1000) return;

      let timer = null;

      const step = () => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        if (maxScroll <= 8) return;

        const isRtl = getComputedStyle(track).direction === 'rtl';
        const delta = Math.max(track.clientWidth * 0.45, 160);
        const current = track.scrollLeft;
        let next = isRtl ? current - delta : current + delta;

        if (!isRtl && next >= maxScroll - 4) next = 0;
        if (isRtl && Math.abs(next) >= maxScroll - 4) next = 0;

        track.scrollTo({ left: next, behavior: 'smooth' });
      };

      const stop = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };

      const start = () => {
        stop();
        timer = window.setInterval(step, speed);
      };

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', (event) => {
        if (!root.contains(event.relatedTarget)) start();
      });
      track.addEventListener('touchstart', stop, { passive: true });
      track.addEventListener(
        'touchend',
        () => {
          window.setTimeout(start, speed);
        },
        { passive: true }
      );

      start();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBrandSliders, { once: true });
  } else {
    initBrandSliders();
  }

  document.addEventListener('shopify:section:load', initBrandSliders);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
